import type { DataModelValidationError } from '../data/loadDataModel';

interface Props {
  errors: DataModelValidationError[];
}

/**
 * Eigenständige Fehlerseite, falls das Datenmodell nicht geladen werden kann (DAT-002, ERR-001).
 * Wird gerendert, bevor Store oder Router aufgebaut werden, damit die App gar nicht erst startet.
 */
export function DataLoadErrorScreen({ errors }: Props) {
  if (import.meta.env.DEV && errors.length > 0) {
    console.error('Datenmodell-Validierung fehlgeschlagen:', errors);
  }

  return (
    <div className="page-container">
      <div className="card stack" style={{ maxWidth: 560, marginInline: 'auto' }}>
        <h1>Die Testdaten konnten nicht geladen werden.</h1>
        <p>
          Bitte lade die Seite neu. Sollte der Fehler bestehen bleiben, wende dich an die
          Betreiberin oder den Betreiber dieser Anwendung.
        </p>
        <button
          type="button"
          className="button button--primary"
          onClick={() => window.location.reload()}
        >
          Neu laden
        </button>
      </div>
    </div>
  );
}
